import * as googleList from './googleGMB.service';
export const GoogleServiceList = {
  ...googleList,
};

